import { forEach, omit } from 'lodash';

import API from 'services/TAPS_API';

export default function getSNU() {
  return API.request({
    method: 'GET',
    url: `/snu`,
    mapper: function (data) {
      return Object.assign({}, data, { snuTypes: mapSnuTypes(data.sections) });
    },
  });
}

function mapSnuTypes(sections = []) {
  const objects = getObjects(sections);
  const snuTypes = {};

  forEach(objects, (object) => {
    let currentObject = omit(object, 'calculationInfo');
    currentObject.taxAgentKey = `${currentObject.taxAgentInn}_${currentObject.taxAgentKpp}_${currentObject.taxAgentName}`;
    forEach(object.calculationInfo, (calcObject) => {
      const snuCalcObject = Object.assign(
        {},
        calcObject,
        { object: currentObject },
        {
          taxAgentInn: currentObject.taxAgentInn,
          taxAgentKpp: currentObject.taxAgentKpp,
          taxAgentName: currentObject.taxAgentName,
        },
      );

      if (snuTypes[calcObject.sectionType]) {
        snuTypes[calcObject.sectionType].push(snuCalcObject);
      } else {
        snuTypes[calcObject.sectionType] = [snuCalcObject];
      }
    });
  });

  return snuTypes;
}

function getObjects(sections) {
  let objects = [];
  forEach(sections, (section) => {
    forEach(section.taxAuthorityInfo, (taxAuthority) => {
      const objectInfo = taxAuthority.objectInfo || taxAuthority.ndfl2Info || [];
      if (objectInfo && objectInfo.length) {
        const extendedObjects = objectInfo.map((object) =>
          Object.assign({}, object, { taxCode: taxAuthority.taxCode }),
        );
        objects.push(...extendedObjects);
      }
    });
  });

  return objects;
}
